
const apply = {
  apply_group_1_title: "Gegevens",
  apply_group_2_title: "Aanvraag",
  apply_group_3_title: "Bevestiging",

  step_intro_label: "Donatie aanvragen",
  step_intro_title: "Welkom {{0}} {{1}}!",
  step_intro_text: "U kunt nu een donatie aanvragen",

  step_aanvrager_label: "donatie aanvragen",
  step_aanvrager_title: "Doet u een aanvraag namens een maatschappelijke organisatie?",
  step_aanvrager_text: "Onder maatschappelijke organisaties verstaan wij stichtingen en verenigingen.",

  step_vind_organisatie_label: "organisatie",
  step_vind_organisatie_title: "Vind uw organisatie",
  step_vind_organisatie_text: "Selecteer de organisatie waarvoor u een aanvraag wilt doen of voer uw organisatiegegevens in als deze bij ons nog niet bekend zijn.",

  step_kies_organisatie_label: "donatie aanvragen voor een organisatie",
  step_kies_organisatie_title: "Selecteer een gekoppelde organisatie",
  step_kies_organisatie_text: "U kunt hier een organisatie selecteren die al aan uw account is gekoppeld.",

  step_maak_organisatie_label: "organisatie",
  step_maak_organisatie_title: "Nieuwe organisatie",

  step_community_toegestaan_label: "donatie aanvragen voor een bewonersinitiatief",
  step_community_toegestaan_title: "Wilt u meer dan € 3000 aanvragen?",
  step_community_toegestaan_text: "Fonds 1818 steunt bewonersinitiatieven met een aanvraagbedrag tot € 3.000.",

  step_community_afgewezen_label: "donatie aanvragen voor een bewonersinitiatief",
  step_community_afgewezen_title: "Fonds 1818 steunt bewonersinitiatieven met een aanvraagbedrag tot € 3.000.",
  step_community_afgewezen_text: "Naast stichtingen en verenigingen kunnen ook groepjes betrokken bewoners uit onze regio een aanvraag doen. We noemen dit type aanvragen bewonersinitiatieven. U bent met minimaal drie initiatiefnemers, er is geen sprake van personeelskosten en het gevraagde bedrag is niet hoger dan € 3.000.",

  step_maak_community_label: "Donatie aanvragen voor een bewonersinitiatief",
  step_maak_community_title: "Vul uw gegevens aan",

  step_kvk_label: "donatie aanvragen voor een organisatie",
  step_kvk_title: "Wat is het KvK-nummer van uw organisatie?",
  step_kvk_text: "Voer het KvK-nummer van uw organisatie in of controleer dit indien het nummer al staat weergegeven. \n" +
      "Mocht uw organisatie het KvK-uittreksel hebben, upload die dan hieronder.",

  step_statuten_vereist_label: "donatie aanvragen voor een organisatie",
  step_statuten_vereist_title: "Is uw stichting of vereniging in oprichting?",

  step_statuten_label: "donatie aanvragen voor een organisatie",
  step_statuten_title: "Upload de statuten van uw stichting of vereniging",
  step_statuten_text: "Mocht u op dit moment de statuten niet bij de hand hebben, dan kunt u klikken op 'volgende'. We dienen de statuten wel te ontvangen voor het overmaken van het donatiebedrag. Houd daar rekening mee.",

  step_jaarrekening_label: "donatie aanvragen voor een organisatie",
  step_jaarrekening_title: "Upload uw meest recente jaarrekening",

  step_tekenbevoegd_label: "tekenbevoegd",
  step_tekenbevoegd_title: "Tekenbevoegd toevoegen",
  step_tekenbevoegd_text: "Voeg een tekenbevoegd persoon toe aan uw registratie.",

  step_tekenbevoegd_vereist_label: "donatie aanvragen voor een organisatie",
  step_tekenbevoegd_vereist_title: "Doet u een aanvraag voor een bedrag van € 10.000 of hoger?",
  step_tekenbevoegd_vereist_text: "Bij aanvragen vanaf € 10.000 moet een tekenbevoegde binnen uw organisatie zijn/haar handtekening zetten.",

  step_tekenbevoegd_vraag_label: "donatie aanvragen voor een organisatie",
  step_tekenbevoegd_vraag_title: "Wie is de tekenbevoegde persoon?",
  step_tekenbevoegd_vraag_text: "U bent zelf al tekenbevoegd. Wilt u nog een tekenbevoegde persoon toevoegen?",

  step_add_contact_question_label: "donatie aanvragen voor een organisatie",
  step_add_contact_question_title: "Wilt u meer contactpersonen koppelen aan uw aanvraag?",
  step_add_contact_question_text: "Als u meerdere contactpersonen toevoegt, dan kunnen zij uw aanvraag eventueel aanvullen en de status ervan volgen.",

  step_add_contact_question_community_label: "donatie aanvragen voor een bewonersinitiatief",
  step_add_contact_question_community_title: "Wilt u mede-initiatiefnemers toevoegen aan uw aanvraag?",
  step_add_contact_question_community_text: "Zorg dat minimaal drie initiatiefnemers (inclusief uzelf) de aanvraag indienen. Uiteindelijk moeten jullie samen het project dragen. Mede-initiatiefnemers zijn buren of wijkgenoten.",

  step_add_contact_label: "donatie aanvragen voor een organisatie",
  step_add_contact_title: "Contactpersoon toevoegen",

  step_add_contact_community_label: "donatie aanvragen voor een bewonersinitiatief",
  step_add_contact_community_title: "Mede-initiatiefnemers toevoegen",
  step_add_contact_community_text: "Zorg dat minimaal drie initiatiefnemers (inclusief uzelf) de aanvraag indienen. Uiteindelijk moeten jullie samen het project dragen. Mede-initiatiefnemers zijn buren of wijkgenoten.",

  step_aanvang_label: "donatie aanvragen",
  step_aanvang_title: "Wat is de aanvangsdatum van het project?",
  step_aanvang_text: "Vul de aanvangsdatum van uw project in. Het project mag op zijn minst over acht weken starten.",

  step_crowdfunding_label: "donatie aanvragen",
  step_crowdfunding_title: "Gaat het om een crowdfunding-project?",

  step_declined_label: "afgewezen",
  step_declined_title: "De aanvang van uw project is kort dag",
  step_declined_text: "We hebben acht weken nodig om uw aanvraag in behandeling te nemen en te beoordelen. Daarom nemen wij alleen aanvragen in behandeling voor projecten die starten over acht weken, tenzij het gaat om een crowdfunding-project. Geef in dat geval tijdens het aanvraagproces aan dat het om crowdfunding gaat.",

  step_projectplan_label: "donatie aanvragen",
  step_projectplan_title: "Upload uw projectplan",
  step_projectplan_text: "Let op dat het plan de volgende informatie bevat: omschrijving, doelstelling, het belang, doelgroep(en), start- en einddatum, sterke en zwakke punten, verwachte resultaten, samenwerkingspartners, het al dan niet inzetten van vrijwilligers.",

  step_begroting_label: "donatie aanvragen",
  step_begroting_title: "Upload de begroting en het dekkingsplan",

  step_offertes_label: "donatie aanvragen",
  step_offertes_title: "Upload offertes en/of andere relevante documenten",
  step_offertes_text: "Als u offertes hebt opgevraagd voor het uitvoeren van uw initiatief, dan kunt u die hier uploaden. Overige relevante documenten zijn een evaluatie van een vorig project, brieven van samenwerkingspartners of afnemers (bijvoorbeeld scholen), bevestigingen van steun door andere fondsen, het bedrijfsleven, de gemeente, etc.",

  step_bedrag_label: "donatie aanvragen",
  step_bedrag_title: "Gevraagd bedrag",

  step_bevesting_label: "donatie aanvragen",
  step_bevesting_title: "Controleer en dien in",

  step_klaar_label: "klaar",
  step_klaar_title: "Uw aanvraag is ingediend!",
  step_klaar_text: "De behandeling van uw aanvraag duurt circa acht weken. In deze tijd krijgt u een van de projectadviseurs als contactpersoon toegewezen en u krijgt een projectnummer, ongeacht of uw aanvraag wordt gehonoreerd of afgewezen.",

  state_ingediend_label: "ingediend",
  state_ingediend_title: "Uw aanvraag is ingediend",
  state_ingediend_text: "U krijgt binnenkort een projectnummer en een projectadviseur toegewezen. Wilt u uw aanvraag aanvullen of wijzigen? Doe dat dan door een reactie te plaatsen via onderstaande knop.",
}

export default apply;
